// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drop-container[data-v-54978dab]{height:100vh}.notes-modal[data-v-54978dab]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:block;z-index:1;min-width:80%}", ""]);
// Exports
module.exports = exports;
